import { AccountTreeResponseDTO } from "../models/AccountTreeDTOs";
import { AccountTreeResultEntity } from "../../domain/entities/AccountTreeEntity";

export class AccountTreeMapper {
  static toResultEntity(dto: AccountTreeResponseDTO): AccountTreeResultEntity {
    const pagination = dto.data?.pagination;
    return {
      success: dto.success,
      groups: dto.data?.groups ?? [],
      pagination: pagination ?? null,
      selectedAccountType: dto.data?.selected_account_type ?? null,
    };
  }
}
